import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var _excluded = ["control", "onUpdated"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Fragment } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { ChevronDownIcon, XIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import { isArray } from 'lodash';
import { Controller } from 'react-hook-form';
import { getLocalTranslation } from '../../utils/i18nKit';
import { Checkbox } from './Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var CountrySelector = function CountrySelector(_ref) {
  var options = _ref.options,
      value = _ref.value,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? getLocalTranslation().$t('common:select_countries') : _ref$label,
      className = _ref.className,
      disabled = _ref.disabled,
      error = _ref.error,
      errorMessage = _ref.errorMessage,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? true : _ref$multiple,
      _ref$withCurrency = _ref.withCurrency,
      withCurrency = _ref$withCurrency === void 0 ? true : _ref$withCurrency,
      onChange = _ref.onChange,
      hideSelectedCountryList = _ref.hideSelectedCountryList;

  var handleOnChange = function handleOnChange(countryArr) {
    if (multiple && isArray(value)) {
      var _newVal;

      var newVal = _toConsumableArray(value);

      var last = countryArr.pop();
      var idx = (_newVal = newVal) === null || _newVal === void 0 ? void 0 : _newVal.findIndex(function (v) {
        return v.code === (last === null || last === void 0 ? void 0 : last.code);
      });

      if (idx > -1) {
        newVal.splice(idx, 1);
      } else {
        newVal = [].concat(_toConsumableArray(newVal), [last]);
      }

      onChange(newVal);
    } else {
      onChange(countryArr);
    }
  };

  var handleRemoveCountry = function handleRemoveCountry(index) {
    if (!isArray(value)) return;

    var newVal = _toConsumableArray(value);

    newVal.splice(index, 1);
    onChange(newVal);
  };

  var focusClass = 'focus-within:border-black focus-within:ring-black focus:outline-none focus-visible:border-gray-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-500';
  return /*#__PURE__*/_jsx(Listbox, {
    value: value,
    disabled: !!disabled,
    onChange: handleOnChange,
    multiple: multiple,
    children: function children(_ref2) {
      var _flags, _flags2;

      var open = _ref2.open;
      return /*#__PURE__*/_jsxs("div", {
        className: "relative",
        children: [/*#__PURE__*/_jsxs(Listbox.Button, {
          className: clsx('relative w-full cursor-pointer rounded-lg border border-gray-300 bg-white py-2 pl-4 pr-10 text-left sm:text-sm', className, focusClass, {
            'pb-1 pt-3': !!label && multiple,
            'py-2': !label && multiple,
            'border-red-500': error,
            'cursor-not-allowed opacity-50': disabled
          }),
          children: [multiple ? /*#__PURE__*/_jsx("div", {
            className: "flex h-9 items-center",
            children: /*#__PURE__*/_jsx("label", {
              className: "pointer-events-none block text-base text-gray-600 text-opacity-60 transition-all",
              children: label
            })
          }) : /*#__PURE__*/_jsx("label", {
            className: clsx("origin-0 -z-1 pointer-events-none absolute left-4 block text-gray-600 transition-all", {
              'top-4 text-base text-gray-400 text-opacity-60': !value,
              'top-2 text-xs': !!value
            }),
            children: label
          }), !multiple && /*#__PURE__*/_jsx("div", {
            className: clsx('flex items-end', {
              'h-9': !!label
            }),
            children: /*#__PURE__*/_jsx("span", {
              className: clsx('numeric-font-fix truncate text-base font-medium text-gray-900', {
                hidden: label && !value
              }),
              children: !!value && /*#__PURE__*/_jsxs("span", {
                className: "numeric-font-fix flex items-center truncate font-bold",
                children: [((_flags = value.flags) === null || _flags === void 0 ? void 0 : _flags.svg_url) && /*#__PURE__*/_jsx("span", {
                  className: "mr-1 block w-4",
                  children: /*#__PURE__*/_jsx("img", {
                    src: (_flags2 = value.flags) === null || _flags2 === void 0 ? void 0 : _flags2.svg_url
                  })
                }), value.name]
              })
            })
          }), /*#__PURE__*/_jsx("span", {
            className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
            children: /*#__PURE__*/_jsx(ChevronDownIcon, {
              className: "h-5 w-5 text-gray-400",
              "aria-hidden": "true"
            })
          })]
        }), error && /*#__PURE__*/_jsx("p", {
          className: "mt-2 text-xs font-bold italic leading-3 text-red-500",
          children: errorMessage
        }), !hideSelectedCountryList && multiple && isArray(value) && /*#__PURE__*/_jsx("div", {
          className: "mt-1 flex flex-wrap",
          children: value === null || value === void 0 ? void 0 : value.map(function (c, index) {
            return /*#__PURE__*/_jsxs("button", {
              type: "button",
              className: "mr-1 mt-1 flex items-center rounded-md border border-black/70 bg-black/5 p-1 transition-colors hover:border-black/50 hover:bg-white hover:text-black/70",
              onClick: function onClick() {
                return handleRemoveCountry(index);
              },
              children: [/*#__PURE__*/_jsx("span", {
                className: "mr-1 text-xs font-semibold",
                children: c.name
              }), /*#__PURE__*/_jsx(XIcon, {
                className: "w-3"
              })]
            }, c.code);
          })
        }), open && /*#__PURE__*/_jsx(Transition, {
          as: Fragment,
          show: open,
          leave: "transition ease-in duration-100",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /*#__PURE__*/_jsx(Listbox.Options, {
            className: "absolute top-14 z-50 mt-1 max-h-72 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm dark:bg-slate-500",
            "static": true,
            children: options === null || options === void 0 ? void 0 : options.map(function (country) {
              return /*#__PURE__*/_jsx(Listbox.Option, {
                className: function className(_ref3) {
                  var active = _ref3.active,
                      disabled = _ref3.disabled;
                  return "hover:bg-brand-primary/70 group relative mb-px flex cursor-pointer select-none items-center justify-between px-4 py-1 last:mb-0 hover:text-white ".concat(active ? 'bg-brand-primary text-white dark:bg-slate-500 dark:text-gray-200 hover:dark:bg-slate-700 ' : 'text-gray-900 dark:bg-slate-500 dark:text-gray-200', " ").concat(disabled ? 'cursor-not-allowed bg-black/5' : '');
                },
                value: country,
                children: function children(_ref4) {
                  var _country$flags, _country$flags2, _country$currencies, _country$currencies$, _country$currencies2, _country$currencies2$;

                  var selected = _ref4.selected,
                      disabled = _ref4.disabled;
                  var isSelected = multiple && isArray(value) ? !!value.find(function (v) {
                    return v.code === country.code;
                  }) : (value === null || value === void 0 ? void 0 : value.code) === country.code;
                  return /*#__PURE__*/_jsxs(_Fragment, {
                    children: [/*#__PURE__*/_jsxs("div", {
                      className: "flex items-center justify-start",
                      children: [/*#__PURE__*/_jsx(Checkbox, {
                        value: country.code,
                        checked: isSelected,
                        label: ""
                      }), /*#__PURE__*/_jsxs("span", {
                        className: "numeric-font-fix truncat flex items-center font-bold",
                        children: [((_country$flags = country.flags) === null || _country$flags === void 0 ? void 0 : _country$flags.svg_url) && /*#__PURE__*/_jsx("span", {
                          className: "mr-1 block w-4 shrink-0",
                          children: /*#__PURE__*/_jsx("img", {
                            src: (_country$flags2 = country.flags) === null || _country$flags2 === void 0 ? void 0 : _country$flags2.svg_url
                          })
                        }), country.name]
                      })]
                    }), withCurrency && /*#__PURE__*/_jsxs("span", {
                      className: "italic text-black/50 group-hover:text-white",
                      children: [(_country$currencies = country.currencies) === null || _country$currencies === void 0 ? void 0 : (_country$currencies$ = _country$currencies[0]) === null || _country$currencies$ === void 0 ? void 0 : _country$currencies$.name, " (", (_country$currencies2 = country.currencies) === null || _country$currencies2 === void 0 ? void 0 : (_country$currencies2$ = _country$currencies2[0]) === null || _country$currencies2$ === void 0 ? void 0 : _country$currencies2$.symbol, ")"]
                    })]
                  });
                }
              }, country.code);
            })
          })
        })]
      });
    }
  });
};
export var CountrySelectorControlled = function CountrySelectorControlled(_ref5) {
  var control = _ref5.control,
      onUpdated = _ref5.onUpdated,
      props = _objectWithoutProperties(_ref5, _excluded);

  return /*#__PURE__*/_jsx(Controller, _objectSpread(_objectSpread({
    control: control
  }, props), {}, {
    render: function render(_ref6) {
      var _ref6$field = _ref6.field,
          value = _ref6$field.value,
          onChange = _ref6$field.onChange;

      var handleOnChange = function handleOnChange(e) {
        onChange(e);
        onUpdated === null || onUpdated === void 0 ? void 0 : onUpdated(e);
      };

      return /*#__PURE__*/_jsx(CountrySelector, _objectSpread(_objectSpread({}, props), {}, {
        value: value,
        onChange: handleOnChange
      }));
    }
  }));
};